/* CUSTOMIZATIONS:
  - added related museum
  - changed PageHeader with PageHeaderText of iovisit-museum
  - modified timetable Info and tickets label
*/

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { PageHeaderText } from 'iovisit-museum-theme/components/Views';

import {
  InfoBox,
  Booking,
  DownloadButton,
  PageMetadata,
  ViewBlocks,
  RichText,
  RelatedItems,
  Ticket,
} from 'iovisit-theme/components/Views';

import { When, Icon } from 'iovisit-theme/components';

const messages = defineMessages({
  eventDate: {
    id: 'event_date',
    defaultMessage: 'Data',
  },
  eventTicket: {
    id: 'event_ticket',
    defaultMessage: 'Biglietti',
  },
  downloadProgram: {
    id: 'event_download_program',
    defaultMessage: 'Scarica programma',
  },
  downloadPoster: {
    id: 'event_download_poster',
    defaultMessage: 'Scarica la locandina',
  },
  related_items: {
    id: 'event_related_items',
    defaultMessage: 'Correlati in evidenza',
  },
  extra_info: {
    id: 'event_extra_info',
    defaultMessage: 'Per saperne di più',
  },
  timetable: { id: 'event_timetable', defaultMessage: 'Orari' },
  prices: { id: 'event_prices', defaultMessage: 'Prezzi' },
});

const EventView = ({ content, location }) => {
  const intl = useIntl();

  const timetableInfos = RichText({
    content: content.further_info_timetables,
  });

  const prices = RichText({
    content: content.prices,
    title: intl.formatMessage(messages.eventTicket),
    titleTag: 'h3',
  });

  const nRelatedMuseum = content.related_museum?.length;

  return (
    <div id="page-event" className="ui container">
      <PageHeaderText content={content} showShareLinks={true} />

      <div className="category-museum">
        <div className="icon-museum">
          <Icon prefix="fas" icon="landmark" className="icon" />
        </div>
        <div className="title-museum">
          {/* Musei correlati */}
          {nRelatedMuseum > 0 &&
            content.related_museum.map((item, index) => {
              return (
                <h3>
                  {item.title}
                  {index !== nRelatedMuseum - 1 && ', '}
                </h3>
              );
            })}
          <When
            start={content.start}
            end={content.end}
            whole_day={content.whole_day}
            open_end={content.open_end}
            show_times={false}
          />
        </div>
      </div>

      <InfoBox>
        <h3>{intl.formatMessage(messages.timetable)}</h3>
        <When
          start={content.start}
          end={content.end}
          whole_day={content.whole_day}
          open_end={content.open_end}
          show_times={true}
          recurrence={content.recurrence}
        />

        {timetableInfos && (
          <div className="timetables-info">{timetableInfos}</div>
        )}

        {prices}

        <Ticket content={content} />

        <Booking content={content} />

        {content.program && (
          <DownloadButton
            file={content.program}
            title={
              content.program_title ??
              intl.formatMessage(messages.downloadProgram)
            }
          />
        )}
        {content.poster && (
          <DownloadButton
            file={content.poster}
            title={
              content.poster_title ??
              intl.formatMessage(messages.downloadPoster)
            }
          />
        )}
      </InfoBox>

      <ViewBlocks content={content} location={location} />

      {/* Approfondimenti */}
      {content.extra_info?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.extra_info)}
          items={content.extra_info}
          background={true}
        />
      )}

      {/* Items correlati */}
      {content.relatedItems?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.related_items)}
          items={content.relatedItems}
          background={(content.extra_info || []).length === 0}
        />
      )}

      <PageMetadata content={content} />
    </div>
  );
};

export default EventView;
